import { render, staticRenderFns } from "./TranslateIcon.vue?vue&type=template&id=49d4edf6&scoped=true&"
import script from "./TranslateIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TranslateIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4edf6",
  null
  
)

export default component.exports